import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Icons from "../../../../Config/Images";
import {
  addToCartAPI,
  getCartAPI,
  updateQuantityInCartAPI,
} from "../../../../Store/Action/cartAction";
import {
  getProductByIdAPI,
  getProductDetailsAPI,
} from "../../../../Store/Action/productAction";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import "./productDetail.css";
import Header from "../../Layout/Header/Header";
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import {
  addWishlistAPI,
  removeWishlistAPI,
} from "../../../../Store/Action/wishlistAction";
import { setCartItemCount } from "../../../../Store/Slice/popupTriggerSlice";
import CustomerReview from "../../CustomerReview";
import VariantSelectionPopup from "../../CustomComponents/VariantSelectionPopup";
import { useParams } from "react-router-dom";

const ProductDetail = () => {
  // State and hooks setup
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(null);
  const [productDetails, setProductDetails] = useState(null);
  const [prodImages, setProdImages] = useState([]);
  const [feedbackRatings, setFeedbackRatings] = useState([]);
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [cartId, setCartId] = useState(null);
  const [isCartFlag, setIsCartFlag] = useState(false);
  // const [isWastageEnabled, setIsWastageEnabled] = useState(true);
  const [userRole, setUserRole] = useState("");
  const [openVariantModal, setOpenVariantModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [popupMode, setPopupMode] = useState("variant");
  const [isLessWeightOpen, setIsLessWeightOpen] = useState(false);
  const [isLabourOpen, setIsLabourOpen] = useState(false);

  const { productId: paramProductId } = useParams();
  const productId = location.state?.productId;
  // const productId = paramProductId || location.state?.productId;

  const isWastageEnabled = useSelector(
    (state) => state.wastage.isWastageEnabled,
  );

  const user = useSelector((state) => state.auth.user);

  const refreshqtyFunc = useCallback(() => {
    dispatch(
      getProductDetailsAPI({ product_id: productId }, (result) => {
        setProductDetails(result?.data?.[0]);
        setQuantity(result?.data?.[0]?.cart_quantity);
        setIsCartFlag(result?.data?.[0]?.flag_cart);
        setIsInWishlist(result?.data?.[0]?.wishlist_id);
        if (
          result?.data?.[0]?.cart_id == null &&
          result?.data?.[0]?.product_quantity == null
        ) {
        }
      }),
    );
  }, []);
  // Fetch product details on mount
  useEffect(() => {
    dispatch(
      getProductByIdAPI(productId, (result) => {
        console.log("productDetail response:", result?.data?.[0]);
        setIsInWishlist(result?.data?.[0]?.wishlist_id);
        setProductDetails(result?.data?.[0]);
        setQuantity(result?.data?.[0]?.cart_quantity);
        setCartId(result?.data?.[0]?.cart_id);
        setIsCartFlag(result?.data?.[0]?.flag_cart);
        setProdImages(result?.data?.[0]?.product_image || []); //temporarily ---------------------------------------------------
        setFeedbackRatings(result?.data?.[0]?.feedback_rating);
      }),
    );
  }, [dispatch, productId]);

  // Fetch cart items on mount
  useEffect(() => {
    dispatch(
      getCartAPI({}, (result) => {
        setCartItems(result?.data || []);
      }),
    );
  }, [dispatch]);

  // Check if the product is already in the cart
  useEffect(() => {
    if (productDetails && cartItems?.length > 0) {
      const productInCart = cartItems.some(
        (item) => item.product_id === productDetails?.product_id,
      );
    }
  }, [cartItems, productDetails]);

  // Handle Add to Cart button click
  const handleAddToCart = (product) => {
    const productType = product?.product_category_type_name?.toLowerCase();

    if (productType === "per pc product") {
      // Direct Add to Cart
      const payload = {
        product_id: product?.product_id,
        quantity: product?.min_quantity,
      };

      dispatch(
        addToCartAPI(payload, (result) => {
          if (result?.status) {
            refreshqtyFunc();
            dispatch(
              getCartAPI({}, (res) => {
                dispatch(setCartItemCount(res?.total_count));
              }),
            );
          } else {
            toast.error(result?.error?.message);
          }
        }),
      );
    } else {
      // Open Variant Popup
      dispatch(
        getProductByIdAPI(product?.product_id, (result) => {
          setSelectedProduct(result.data[0]);
          setPopupMode("variant");
          setOpenVariantModal(true);
        }),
      );
    }
  };

  // const renderDetailItem = (label, value1, value2) => (
  //   <div className="detail-item">
  //     <span className="label">{label}</span>
  //     {/* <span className="value">: {value}</span> */}
  //     <span className="value">
  //       : {value1} {value2 && `, ${value2}`}
  //     </span>
  //   </div>
  // );
  const renderDetailItem = (label, value1, value2, tooltip) => (
    <div className="detail-item">
      <span className="label">{label}</span>
      <span className="value" title={tooltip || undefined}>
        : {value1} {value2 && `, ${value2}`}
      </span>
    </div>
  );

  // Manage quantity
  const updateQuantity = (delta, action, productDataa) => {
    const productType = productDataa?.product_category_type_name?.toLowerCase();

    if (productType !== "per pc product") {
      const params = {
        product_id: productDataa?.product_id,
      };
      dispatch(
        getProductByIdAPI(params.product_id, (result) => {
          setOpenVariantModal(true);
          setSelectedProduct(result.data[0]);
        }),
      );
      return;
    }

    let currentQty = Number(productDataa?.cart_quantity);

    if (action == "isIncrement") {
      currentQty += 1;
    } else if (action === "isDecrement") {
      currentQty -= 1;
    }

    const data = {
      // action,
      cart_id: cartId,
      product_id: productDetails?.product_id,
      quantity: currentQty,
    };

    dispatch(
      addToCartAPI(data, (result) => {
        if (result?.status) {
          refreshqtyFunc();
          dispatch(
            getCartAPI({}, (result) => {
              const cartLength = result?.total_count;
              dispatch(setCartItemCount(cartLength));
            }),
          );
          // toast.success(result?.message?.message);
        } else {
          toast.error(result?.error?.message);
        }
      }),
    );
  };

  const handlePreOrderClick = (e, product) => {
    // dispatch(
    //   getProductByIdAPI(product?.product_id, (result) => {
    //     setSelectedProduct(result.data[0]);
    //     setPopupMode("preorder");
    //     setOpenVariantModal(true);
    //   })
    // );
    const reqData = {
      product_id: product?.product_id,
      flag_pre_order: true,
      // pre_order_weight: data?.pre_order_weight,
    };

    dispatch(
      addWishlistAPI(reqData, (result) => {
        if (result?.status) {
          toast?.success(result?.data?.message?.message);
          refreshqtyFunc();
          setOpenVariantModal(false);
          // navigate("/wishlist");
        }
      }),
    );
  };

  const handleMoveToWishlist = (product) => {
    const requestWishlistData = {
      product_id: product?.product_id,
      // isMoveToWishlist: true,
    };
    dispatch(
      addWishlistAPI(requestWishlistData, (isSuccess, result) => {
        if (result?.status) {
          // onClose();
          // onGetWishlist();
          refreshqtyFunc();
          // toast.success(result?.message?.message);
        } else {
          // onClose();
          toast.error(result?.message?.message);
        }
      }),
    );
  };
  const handleRemoveFromWishlist = (product) => {
    const reqBody = {
      wishlist_id: product?.wishlist_id,
      flag_deleted: true,
    };
    dispatch(
      removeWishlistAPI(reqBody, (result) => {
        if (result?.status === true) {
          refreshqtyFunc();
        } else {
          // toast.error(result?.message?.message);
          toast.error("something went wrong!");
        }
      }),
    );
  };
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({ x: 50, y: 50 });
  const imageContainerRef = useRef(null);

  const handleZoomToggle = (e) => {
    if (!imageContainerRef.current) return;

    if (isZoomed) {
      setIsZoomed(false);
    } else {
      const rect = imageContainerRef.current.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      setZoomPosition({ x, y }); // Ensure immediate zoom position update
      setIsZoomed(true);
    }
  };

  // Handle mouse move for zoom effect
  const handleMouseMove = (e) => {
    if (!isZoomed || !imageContainerRef.current) return;

    const rect = imageContainerRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    setZoomPosition({ x, y });
  };

  const handleTouchMove = (e) => {
    if (!isZoomed || !imageContainerRef.current) return;

    const rect = imageContainerRef.current.getBoundingClientRect();
    const touch = e.touches[0]; // Get first touch point
    const x = ((touch.clientX - rect.left) / rect.width) * 100;
    const y = ((touch.clientY - rect.top) / rect.height) * 100;

    setZoomPosition({ x, y });
  };

  // Handle image slide
  const handleImageSlide = (e, direction) => {
    e.stopPropagation();
    setCurrentImageIndex((prevIndex) =>
      direction === "next"
        ? (prevIndex + 1) % prodImages.length
        : (prevIndex - 1 + prodImages.length) % prodImages.length,
    );
    setIsZoomed(false); // Reset zoom when changing images
  };

  const [visibleImagesStartIndex, setVisibleImagesStartIndex] = useState(0);
  const totalVisibleImages = 3; // Number of images visible at a time
  const handleScrollImages = (direction) => {
    if (direction === "up" && visibleImagesStartIndex > 0) {
      setVisibleImagesStartIndex(visibleImagesStartIndex - 1);
    } else if (
      direction === "down" &&
      visibleImagesStartIndex < prodImages.length - 3
    ) {
      setVisibleImagesStartIndex(visibleImagesStartIndex + 1);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        imageContainerRef.current &&
        !imageContainerRef.current.contains(event.target)
      ) {
        // If zoom is active and clicked outside, disable zoom
        if (isZoomed) {
          setIsZoomed(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isZoomed]);

  const handleSubmitVariant = (selectedVariantIds) => {
    const payload = {
      product_id: selectedProduct?.product_id,
      product_variant_id: selectedVariantIds,
    };

    dispatch(
      addToCartAPI(payload, (result) => {
        if (result?.status) {
          setOpenVariantModal(false);
          refreshqtyFunc();
          dispatch(
            getCartAPI({}, (res) => {
              dispatch(setCartItemCount(res?.total_count));
            }),
          );
        } else {
          toast.error(result?.error?.message);
        }
      }),
    );
  };

  const handlePreOrderSubmit = (data) => {
    const reqData = {
      product_id: data?.product_id,
      // pre_order_weight: data?.pre_order_weight,
      flag_pre_order: true,
    };

    dispatch(
      addWishlistAPI(reqData, (result) => {
        if (result?.status) {
          toast?.success(result?.data?.message?.message);
          refreshqtyFunc();
          setOpenVariantModal(false);
          // navigate("/wishlist");
        }
      }),
    );
  };

  const lessWeightBreakdown = productDetails?.product_less_weight_details
    ?.map((d) => `${d.product_component_type_name}: ${d.weight_value}g`)
    .join(", ");

  const labourBreakdown = productDetails?.product_labour_amount_details
    ?.map((d) => `${d.product_component_type_name}: ₹${d.amount_value}`)
    .join(", ");
  return (
    <>
      <Header />
      <div className="productDetailPageDiv">
        <div className="left-side-div">
          <div className="multi-imgs">
            {prodImages.length > 3 && (
              <div
                className={`upVector-img ${
                  visibleImagesStartIndex === 0 ? "disabled" : ""
                }`}
                onClick={() => handleScrollImages("up")}
              >
                <img src={Icons?.vectorUpIcon} alt="Scroll Up" />
              </div>
            )}
            {/* {prodImages.slice(0, 3).map((image, index) => (
              <div
                key={index}
                className={`img${index + 1}`}
                onClick={() => setCurrentImageIndex(index)}
                // onMouseMove={handleMouseMove}
              >
                <CustomImageComponent
                  src={`${image?.product_image_url}`}
                  height={`130px`}
                  width={`100%`}
                />
              </div>
            ))} */}
            {/* Display 3 images at a time */}
            {prodImages
              .slice(visibleImagesStartIndex, visibleImagesStartIndex + 3)
              .map((image, index) => (
                <div
                  key={index}
                  className={`img${index + 1}`}
                  onClick={() =>
                    setCurrentImageIndex(visibleImagesStartIndex + index)
                  }
                >
                  <CustomImageComponent
                    src={`${image?.product_image_url}`}
                    height={`130px`}
                    width={`100%`}
                  />
                </div>
              ))}
            {prodImages.length > 3 && (
              <div
                className={`downVector-img ${
                  visibleImagesStartIndex >=
                  prodImages.length - totalVisibleImages
                    ? "disabled"
                    : ""
                }`}
                onClick={() => handleScrollImages("down")}
              >
                <img src={Icons?.vectorDownIcon} alt="Scroll Down" />
              </div>
            )}
          </div>

          <div
            ref={imageContainerRef}
            className="big-img"
            style={{
              cursor: isZoomed ? "zoom-out" : "zoom-in",
              overflow: "hidden",
              position: "relative",
            }}
            onClick={handleZoomToggle}
            onMouseMove={handleMouseMove}
            onTouchMove={handleTouchMove}
          >
            <CustomImageComponent
              width={"100%"}
              height={"100%"}
              src={`${prodImages[currentImageIndex]?.product_image_url}`}
              style={{
                transition: "transform 0.3s ease",
                transform: isZoomed ? "scale(3)" : "scale(1)",
                transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`,
              }}
            />
            {productDetails?.product_status_name == "Out of stock" && (
              <div className="out-of-stock-label">Out of Stock</div>
            )}
            <div className="sliders">
              <div
                className="left-slider"
                onClick={(e) => handleImageSlide(e, "prev")}
              >
                <img src={Icons.arrowLeftSliderIcon} alt="Previous" />
              </div>
              <div
                className="right-slider"
                onClick={(e) => handleImageSlide(e, "next")}
              >
                <img src={Icons.arrowRightSliderIcon} alt="Next" />
              </div>
            </div>
          </div>
        </div>

        <div className="right-side-div">
          {productDetails ? (
            <>
              <div className="heading">
                {/* <p>
                  {productDetails?.product_subCategory_name &&
                  productDetails?.stamp_purity_value
                    ? `${productDetails?.product_subCategory_name} (${productDetails?.stamp_purity_value}, ${productDetails?.stamp_melting_purity_value})`
                    : `${productDetails?.product_name}`}
                </p> */}
                <p>{productDetails?.product_name} </p>

                {/* ❤️ Wishlist Icon */}
                <div
                  onClick={() => {
                    isInWishlist
                      ? handleRemoveFromWishlist(productDetails)
                      : handleMoveToWishlist(productDetails);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={
                      isInWishlist ? Icons.redWishlistIcon : Icons.wishlistIcon
                    }
                    alt="wishlist"
                    style={{ height: "22px" }}
                    className=""
                  />
                </div>
              </div>
              {/* <div className="separator" /> */}
              <div className="seperator-hr" />

              <div className="paragraph-parra">
                <p>{productDetails.product_description}</p>
              </div>

              <div className="prod-detail-content">
                <div className="left-cont">
                  <>
                    {(
                      productDetails?.product_category_type_name || ""
                    ).toLowerCase() === "product"
                      ? isWastageEnabled === true &&
                        productDetails?.mode_name === "Wastage" &&
                        renderDetailItem(
                          "Wastage",
                          productDetails?.product_wastage,
                        )
                      : renderDetailItem(
                          "Per Pc rate",
                          productDetails?.product_per_pc_rate,
                        )}

                    {(
                      productDetails?.product_category_type_name || ""
                    ).toLowerCase() === "product" &&
                      renderDetailItem(
                        "Melting (Purity)",
                        `${productDetails?.product_melting_value} (${productDetails?.product_stamp_value})`,
                      )}

                    {renderDetailItem(
                      "Metal",
                      productDetails.product_metal_name,
                    )}
                    {renderDetailItem(
                      "Brand",
                      `${productDetails?.user_shop_name}`,
                    )}
                  </>

                  {renderDetailItem(
                    "Category",
                    productDetails.product_category_name,
                  )}
                  {renderDetailItem(
                    "Sub category",
                    productDetails.sub_category_name,
                  )}

                  {renderDetailItem(
                    "Color Stone",
                    productDetails.color_stone_name,
                  )}
                </div>
                <div className="right-cont">
                  {renderDetailItem(
                    "Product Code",
                    `${productDetails?.product_code}`,
                  )}
                  {renderDetailItem(
                    "Gross Weight",
                    `${productDetails.product_avg_gross_weight} g`,
                  )}
                  {/* {renderDetailItem(
                    "Less Weight",
                    `${productDetails.product_avg_less_weight} g`,
                  )} */}
                  <div className="detail-item less-weight-item">
                    <span className="label">Less Weight</span>
                    <span
                      className="value less-weight-toggle"
                      onClick={() =>
                        lessWeightBreakdown &&
                        setIsLessWeightOpen((prev) => !prev)
                      }
                    >
                      : {productDetails.product_avg_less_weight} g
                      {lessWeightBreakdown && (
                        <img
                          src={Icons.vectorDownIcon}
                          alt="Toggle breakdown"
                          className={`less-weight-chevron ${isLessWeightOpen ? "open" : ""}`}
                        />
                      )}
                    </span>

                    {isLessWeightOpen && lessWeightBreakdown && (
                      <div className="less-weight-dropdown">
                        {productDetails.product_less_weight_details.map((d) => (
                          <div
                            className="less-weight-row"
                            key={d.product_less_weight_detail_id}
                          >
                            <span>{d.product_component_type_name}</span>
                            <span>{d.weight_value} g</span>
                          </div>
                        ))}
                        <div className="less-weight-row less-weight-total">
                          <span>Total</span>
                          <span>
                            {productDetails.product_avg_less_weight} g
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  {renderDetailItem(
                    "Net Weight",
                    `${productDetails.product_avg_net_weight} g`,
                  )}
                              
                  {productDetails?.is_labour_enabled && (
                    <div className="detail-item less-weight-item">
                      <span className="label">
                        Labour{" "}
                        {productDetails?.labour_type_code
                          ? `(${productDetails.labour_type_code})`
                          : ""}
                      </span>
                      <span
                        className="value less-weight-toggle"
                        onClick={() =>
                          labourBreakdown && setIsLabourOpen((prev) => !prev)
                        }
                      >
                        : ₹{productDetails.product_labour_amount}
                        {labourBreakdown && (
                          <img
                            src={Icons.vectorDownIcon}
                            alt="Toggle breakdown"
                            className={`less-weight-chevron ${isLabourOpen ? "open" : ""}`}
                          />
                        )}
                      </span>

                      {isLabourOpen && labourBreakdown && (
                        <div className="less-weight-dropdown">
                          {productDetails.product_labour_amount_details.map(
                            (d) => (
                              <div
                                className="less-weight-row"
                                key={d.product_labour_amount_detail_id}
                              >
                                <span>{d.product_component_type_name}</span>
                                <span>₹{d.amount_value}</span>
                              </div>
                            ),
                          )}
                          <div className="less-weight-row less-weight-total">
                            <span>Total</span>
                            <span>₹{productDetails.product_labour_amount}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="btns">
                {/* {isInWishlist ? (
                  <>
                    <div
                      onClick={() => handleRemoveFromWishlist(productDetails)}
                      className="wishlist-btn-in-product-detail"
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={Icons.redWishlistIcon}
                        style={{ height: "20px" }}
                        alt=""
                      />
                      <span> Wishlisted </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      onClick={() => handleMoveToWishlist(productDetails)}
                      className="wishlist-btn-in-product-detail"
                    >
                      Move to wishlist
                    </div>
                  </>
                )} */}

                {productDetails?.product_status_name === "Out of stock" ? (
                  <div
                    className="add-to-cart-btn"
                    style={{
                      color: "#ffffff",
                      backgroundColor: "#000000",
                      cursor: productDetails?.flag_pre_order
                        ? "not-allowed"
                        : "pointer",
                      pointerEvents: productDetails?.flag_pre_order
                        ? "none"
                        : "auto",
                      opacity: productDetails?.flag_pre_order ? 0.6 : 1,
                    }}
                    onClick={(e) => handlePreOrderClick(e, productDetails)}
                    disabled={productDetails?.flag_pre_order}
                  >
                    Pre-Order
                  </div>
                ) : isCartFlag ? (
                  <>
                    {productDetails?.product_category_type_name?.toLowerCase() !==
                    "per pc product" ? (
                      <>
                        {/* <div
                          className="add-to-cart-btn"
                          onClick={() => {
                            setPopupMode("mode"); // 🔥 show mode (change variant)
                            handleAddToCart(productDetails);
                          }}
                        >
                          {"Change Variant"}
                        </div> */}
                        <>
                          <div className="inc-dec-div">
                            <div
                              className="dec-btn"
                              onClick={() => {
                                setPopupMode("mode"); // 🔥 show mode (change variant)
                                handleAddToCart(productDetails);
                              }}
                            >
                              <img
                                src={Icons.minusCircleIcon}
                                alt="Decrease quantity"
                              />
                            </div>
                            <div className="value-btn">{quantity}</div>
                            <div
                              className="inc-btn"
                              onClick={() => {
                                setPopupMode("mode"); // 🔥 show mode (change variant)
                                handleAddToCart(productDetails);
                              }}
                            >
                              <img
                                src={Icons.addCircleIcon}
                                alt="Increase quantity"
                              />
                            </div>
                          </div>
                        </>
                      </>
                    ) : (
                      <>
                        <div className="inc-dec-div">
                          <div
                            className="dec-btn"
                            onClick={() =>
                              updateQuantity(-1, "isDecrement", productDetails)
                            }
                          >
                            <img
                              src={Icons.minusCircleIcon}
                              alt="Decrease quantity"
                            />
                          </div>
                          <div className="value-btn">{quantity}</div>
                          <div
                            className="inc-btn"
                            onClick={() =>
                              updateQuantity(1, "isIncrement", productDetails)
                            }
                          >
                            <img
                              src={Icons.addCircleIcon}
                              alt="Increase quantity"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  // <div className="add-to-cart-btn" onClick={handleAddToCart}>
                  <div
                    className="add-to-cart-btn"
                    onClick={() => handleAddToCart(productDetails)}
                  >
                    Add to cart
                  </div>
                )}
              </div>
            </>
          ) : (
            <p>Loading product details...</p>
          )}
        </div>
      </div>
      {feedbackRatings?.length > 0 && (
        <CustomerReview feedbackRatings={feedbackRatings} />
      )}
      <VariantSelectionPopup
        open={openVariantModal}
        mode={popupMode}
        onClose={() => setOpenVariantModal(false)}
        product={selectedProduct}
        onSubmit={handleSubmitVariant}
        onPreOrderSubmit={handlePreOrderSubmit}
      />
    </>
  );
};

export default ProductDetail;
